import { Skeleton } from '@/shared/ui/skeleton';

import type { ListStatDef } from '../model/types';
import type { ListPageController } from '../model/useListPageController';

/**
 * Souhrnný pruh (anatomie region 4) — řada agregátů nad aktuálním filtrem. Vykreslí se jen
 * je-li zapnutý (`controller.statsOpen`) a šablona má definice; hodnoty počítá BE přes
 * `api.stats`, dokud doběhnou, ukazuje skeleton.
 */
export function StatsStrip<TItem>({
  controller,
  defs,
}: {
  controller: ListPageController<TItem>;
  defs?: ListStatDef<unknown>[];
}) {
  if (!defs || defs.length === 0 || !controller.statsOpen) {
    return null;
  }

  const stats = controller.stats;
  const pending = controller.statsLoading && stats === undefined;

  return (
    <div className="phxlist-stats">
      {defs.map((def) => (
        <div key={def.key} className="phxlist-stat">
          <span className="phxlist-stat-label">{def.label}</span>
          <span className="phxlist-stat-value">
            {pending ? (
              <Skeleton className="h-[14px] w-[64px]" />
            ) : stats !== undefined ? (
              def.value(stats)
            ) : (
              '—'
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
